"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.EMPHASIS = void 0;
var _react = _interopRequireDefault(require("react"));
var _BaseButton = _interopRequireWildcard(require("./BaseButton"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _jsxRuntime = require("react/jsx-runtime");
var EMPHASIS = exports.EMPHASIS = _BaseButton.EMPHASIS;
var DropDownButton = (0, _styledComponents.default)(_BaseButton.default).withConfig({
  displayName: "ButtonDropdown__DropDownButton",
  componentId: "sc-tia5nq-0"
})(["&[data-state='open']{svg.right-icon{transform:rotate(-180deg);}}"]);
var ButtonDropdown = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var _ref$emphasis = _ref.emphasis,
    emphasis = _ref$emphasis === void 0 ? EMPHASIS.HIGH : _ref$emphasis,
    disabled = _ref.disabled,
    icon = _ref.icon,
    children = _ref.children,
    onClick = _ref.onClick,
    props = _objectWithoutProperties(_ref, ["emphasis", "disabled", "icon", "children", "onClick"]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(DropDownButton, _objectSpread({}, props, {
    emphasis: emphasis,
    disabled: disabled,
    leftIcon: icon,
    rightIcon: 'chevronDown',
    ref: ref,
    useButtonProps: false,
    children: children
  }));
});
var _default = exports.default = ButtonDropdown;